// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/common/v1/execution_scope.proto (package mono.common.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * ExecutionArtifactKind is the normalized governing-artifact kind. Preserve the
 * raw document label alongside this value. OTHER and UNKNOWN are required.
 *
 * @generated from enum mono.common.v1.ExecutionArtifactKind
 */ export var ExecutionArtifactKind = /*#__PURE__*/ function(ExecutionArtifactKind) {
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_UNSPECIFIED = 0;
   */ ExecutionArtifactKind[ExecutionArtifactKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_SOW = 1;
   */ ExecutionArtifactKind[ExecutionArtifactKind["SOW"] = 1] = "SOW";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_EXECUTION_PLAN = 2;
   */ ExecutionArtifactKind[ExecutionArtifactKind["EXECUTION_PLAN"] = 2] = "EXECUTION_PLAN";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_LOE = 3;
   */ ExecutionArtifactKind[ExecutionArtifactKind["LOE"] = 3] = "LOE";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_WORK_AUTHORIZATION = 4;
   */ ExecutionArtifactKind[ExecutionArtifactKind["WORK_AUTHORIZATION"] = 4] = "WORK_AUTHORIZATION";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_TASK_PLAN = 5;
   */ ExecutionArtifactKind[ExecutionArtifactKind["TASK_PLAN"] = 5] = "TASK_PLAN";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_TECHNICAL_DIRECTION = 6;
   */ ExecutionArtifactKind[ExecutionArtifactKind["TECHNICAL_DIRECTION"] = 6] = "TECHNICAL_DIRECTION";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_EMAIL_APPROVAL = 7;
   */ ExecutionArtifactKind[ExecutionArtifactKind["EMAIL_APPROVAL"] = 7] = "EMAIL_APPROVAL";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_MEMORANDUM = 8;
   */ ExecutionArtifactKind[ExecutionArtifactKind["MEMORANDUM"] = 8] = "MEMORANDUM";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_PWS_EXCERPT = 9;
   */ ExecutionArtifactKind[ExecutionArtifactKind["PWS_EXCERPT"] = 9] = "PWS_EXCERPT";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_OTHER = 10;
   */ ExecutionArtifactKind[ExecutionArtifactKind["OTHER"] = 10] = "OTHER";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_KIND_UNKNOWN = 11;
   */ ExecutionArtifactKind[ExecutionArtifactKind["UNKNOWN"] = 11] = "UNKNOWN";
    return ExecutionArtifactKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionArtifactKind)
proto3.util.setEnumType(ExecutionArtifactKind, "mono.common.v1.ExecutionArtifactKind", [
    {
        no: 0,
        name: "EXECUTION_ARTIFACT_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_ARTIFACT_KIND_SOW"
    },
    {
        no: 2,
        name: "EXECUTION_ARTIFACT_KIND_EXECUTION_PLAN"
    },
    {
        no: 3,
        name: "EXECUTION_ARTIFACT_KIND_LOE"
    },
    {
        no: 4,
        name: "EXECUTION_ARTIFACT_KIND_WORK_AUTHORIZATION"
    },
    {
        no: 5,
        name: "EXECUTION_ARTIFACT_KIND_TASK_PLAN"
    },
    {
        no: 6,
        name: "EXECUTION_ARTIFACT_KIND_TECHNICAL_DIRECTION"
    },
    {
        no: 7,
        name: "EXECUTION_ARTIFACT_KIND_EMAIL_APPROVAL"
    },
    {
        no: 8,
        name: "EXECUTION_ARTIFACT_KIND_MEMORANDUM"
    },
    {
        no: 9,
        name: "EXECUTION_ARTIFACT_KIND_PWS_EXCERPT"
    },
    {
        no: 10,
        name: "EXECUTION_ARTIFACT_KIND_OTHER"
    },
    {
        no: 11,
        name: "EXECUTION_ARTIFACT_KIND_UNKNOWN"
    }
]);
/**
 * ExecutionScopeRevisionState is the revision-level status. Scope-level status
 * is a summary; contractual activation is derived per commitment.
 *
 * @generated from enum mono.common.v1.ExecutionScopeRevisionState
 */ export var ExecutionScopeRevisionState = /*#__PURE__*/ function(ExecutionScopeRevisionState) {
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_UNSPECIFIED = 0;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_DRAFT = 1;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["DRAFT"] = 1] = "DRAFT";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_UNDER_REVIEW = 2;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["UNDER_REVIEW"] = 2] = "UNDER_REVIEW";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_APPROVED_PENDING_AUTHORITY = 3;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["APPROVED_PENDING_AUTHORITY"] = 3] = "APPROVED_PENDING_AUTHORITY";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_AUTHORIZED_FUTURE = 4;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["AUTHORIZED_FUTURE"] = 4] = "AUTHORIZED_FUTURE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_ACTIVE = 5;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["ACTIVE"] = 5] = "ACTIVE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_EXPIRED = 6;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["EXPIRED"] = 6] = "EXPIRED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_SUPERSEDED = 7;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["SUPERSEDED"] = 7] = "SUPERSEDED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_REVISION_STATE_CANCELLED = 8;
   */ ExecutionScopeRevisionState[ExecutionScopeRevisionState["CANCELLED"] = 8] = "CANCELLED";
    return ExecutionScopeRevisionState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionScopeRevisionState)
proto3.util.setEnumType(ExecutionScopeRevisionState, "mono.common.v1.ExecutionScopeRevisionState", [
    {
        no: 0,
        name: "EXECUTION_SCOPE_REVISION_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SCOPE_REVISION_STATE_DRAFT"
    },
    {
        no: 2,
        name: "EXECUTION_SCOPE_REVISION_STATE_UNDER_REVIEW"
    },
    {
        no: 3,
        name: "EXECUTION_SCOPE_REVISION_STATE_APPROVED_PENDING_AUTHORITY"
    },
    {
        no: 4,
        name: "EXECUTION_SCOPE_REVISION_STATE_AUTHORIZED_FUTURE"
    },
    {
        no: 5,
        name: "EXECUTION_SCOPE_REVISION_STATE_ACTIVE"
    },
    {
        no: 6,
        name: "EXECUTION_SCOPE_REVISION_STATE_EXPIRED"
    },
    {
        no: 7,
        name: "EXECUTION_SCOPE_REVISION_STATE_SUPERSEDED"
    },
    {
        no: 8,
        name: "EXECUTION_SCOPE_REVISION_STATE_CANCELLED"
    }
]);
/**
 * ExecutionWorkItemKind classifies a work item. Contractuality is NOT this
 * enum — see commercial treatment and authority basis as independent axes.
 *
 * @generated from enum mono.common.v1.ExecutionWorkItemKind
 */ export var ExecutionWorkItemKind = /*#__PURE__*/ function(ExecutionWorkItemKind) {
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_UNSPECIFIED = 0;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_CONTRACTUAL_DELIVERABLE = 1;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["CONTRACTUAL_DELIVERABLE"] = 1] = "CONTRACTUAL_DELIVERABLE";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_CONTRACTUAL_ACTIVITY = 2;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["CONTRACTUAL_ACTIVITY"] = 2] = "CONTRACTUAL_ACTIVITY";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_WORK_PRODUCT = 3;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["WORK_PRODUCT"] = 3] = "WORK_PRODUCT";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_MILESTONE = 4;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["MILESTONE"] = 4] = "MILESTONE";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_CUSTOMER_REQUEST = 5;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["CUSTOMER_REQUEST"] = 5] = "CUSTOMER_REQUEST";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_INTERNAL_ACTIVITY = 6;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["INTERNAL_ACTIVITY"] = 6] = "INTERNAL_ACTIVITY";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_EVIDENCE_ARTIFACT = 7;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["EVIDENCE_ARTIFACT"] = 7] = "EVIDENCE_ARTIFACT";
    /**
   * @generated from enum value: EXECUTION_WORK_ITEM_KIND_UNKNOWN = 8;
   */ ExecutionWorkItemKind[ExecutionWorkItemKind["UNKNOWN"] = 8] = "UNKNOWN";
    return ExecutionWorkItemKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionWorkItemKind)
proto3.util.setEnumType(ExecutionWorkItemKind, "mono.common.v1.ExecutionWorkItemKind", [
    {
        no: 0,
        name: "EXECUTION_WORK_ITEM_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_WORK_ITEM_KIND_CONTRACTUAL_DELIVERABLE"
    },
    {
        no: 2,
        name: "EXECUTION_WORK_ITEM_KIND_CONTRACTUAL_ACTIVITY"
    },
    {
        no: 3,
        name: "EXECUTION_WORK_ITEM_KIND_WORK_PRODUCT"
    },
    {
        no: 4,
        name: "EXECUTION_WORK_ITEM_KIND_MILESTONE"
    },
    {
        no: 5,
        name: "EXECUTION_WORK_ITEM_KIND_CUSTOMER_REQUEST"
    },
    {
        no: 6,
        name: "EXECUTION_WORK_ITEM_KIND_INTERNAL_ACTIVITY"
    },
    {
        no: 7,
        name: "EXECUTION_WORK_ITEM_KIND_EVIDENCE_ARTIFACT"
    },
    {
        no: 8,
        name: "EXECUTION_WORK_ITEM_KIND_UNKNOWN"
    }
]);
/**
 * ExecutionAuthorityBasis identifies the claimed basis. It does not itself
 * make a legal conclusion.
 *
 * @generated from enum mono.common.v1.ExecutionAuthorityBasis
 */ export var ExecutionAuthorityBasis = /*#__PURE__*/ function(ExecutionAuthorityBasis) {
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_UNSPECIFIED = 0;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_AWARD = 1;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["AWARD"] = 1] = "AWARD";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_MODIFICATION = 2;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["MODIFICATION"] = 2] = "MODIFICATION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_INCORPORATED_SCOPE_ARTIFACT = 3;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["INCORPORATED_SCOPE_ARTIFACT"] = 3] = "INCORPORATED_SCOPE_ARTIFACT";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_STANDALONE_SCOPE_ARTIFACT = 4;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["STANDALONE_SCOPE_ARTIFACT"] = 4] = "STANDALONE_SCOPE_ARTIFACT";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_WORK_AUTHORIZATION = 5;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["WORK_AUTHORIZATION"] = 5] = "WORK_AUTHORIZATION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_WRITTEN_DIRECTION = 6;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["WRITTEN_DIRECTION"] = 6] = "WRITTEN_DIRECTION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_EMAIL_CONCURRENCE = 7;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["EMAIL_CONCURRENCE"] = 7] = "EMAIL_CONCURRENCE";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_INTERNAL_PLAN = 8;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["INTERNAL_PLAN"] = 8] = "INTERNAL_PLAN";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_MANUAL_ASSERTION = 9;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["MANUAL_ASSERTION"] = 9] = "MANUAL_ASSERTION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_BASIS_UNKNOWN = 10;
   */ ExecutionAuthorityBasis[ExecutionAuthorityBasis["UNKNOWN"] = 10] = "UNKNOWN";
    return ExecutionAuthorityBasis;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionAuthorityBasis)
proto3.util.setEnumType(ExecutionAuthorityBasis, "mono.common.v1.ExecutionAuthorityBasis", [
    {
        no: 0,
        name: "EXECUTION_AUTHORITY_BASIS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_AUTHORITY_BASIS_AWARD"
    },
    {
        no: 2,
        name: "EXECUTION_AUTHORITY_BASIS_MODIFICATION"
    },
    {
        no: 3,
        name: "EXECUTION_AUTHORITY_BASIS_INCORPORATED_SCOPE_ARTIFACT"
    },
    {
        no: 4,
        name: "EXECUTION_AUTHORITY_BASIS_STANDALONE_SCOPE_ARTIFACT"
    },
    {
        no: 5,
        name: "EXECUTION_AUTHORITY_BASIS_WORK_AUTHORIZATION"
    },
    {
        no: 6,
        name: "EXECUTION_AUTHORITY_BASIS_WRITTEN_DIRECTION"
    },
    {
        no: 7,
        name: "EXECUTION_AUTHORITY_BASIS_EMAIL_CONCURRENCE"
    },
    {
        no: 8,
        name: "EXECUTION_AUTHORITY_BASIS_INTERNAL_PLAN"
    },
    {
        no: 9,
        name: "EXECUTION_AUTHORITY_BASIS_MANUAL_ASSERTION"
    },
    {
        no: 10,
        name: "EXECUTION_AUTHORITY_BASIS_UNKNOWN"
    }
]);
/**
 * ExecutionCommercialTreatment is independent of contractuality. A contractual
 * FFP output can be INCLUDED_IN_CLIN_PRICE; "not separately invoiced" never
 * implies "noncontractual."
 *
 * @generated from enum mono.common.v1.ExecutionCommercialTreatment
 */ export var ExecutionCommercialTreatment = /*#__PURE__*/ function(ExecutionCommercialTreatment) {
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_UNSPECIFIED = 0;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_SEPARATELY_INVOICED = 1;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["SEPARATELY_INVOICED"] = 1] = "SEPARATELY_INVOICED";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_INCLUDED_IN_CLIN_PRICE = 2;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["INCLUDED_IN_CLIN_PRICE"] = 2] = "INCLUDED_IN_CLIN_PRICE";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_NOT_SEPARATELY_PRICED = 3;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["NOT_SEPARATELY_PRICED"] = 3] = "NOT_SEPARATELY_PRICED";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_NON_BILLABLE = 4;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["NON_BILLABLE"] = 4] = "NON_BILLABLE";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_UNFUNDED = 5;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["UNFUNDED"] = 5] = "UNFUNDED";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_POTENTIAL_CHANGE = 6;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["POTENTIAL_CHANGE"] = 6] = "POTENTIAL_CHANGE";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_DISPUTED = 7;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["DISPUTED"] = 7] = "DISPUTED";
    /**
   * @generated from enum value: EXECUTION_COMMERCIAL_TREATMENT_UNKNOWN = 8;
   */ ExecutionCommercialTreatment[ExecutionCommercialTreatment["UNKNOWN"] = 8] = "UNKNOWN";
    return ExecutionCommercialTreatment;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionCommercialTreatment)
proto3.util.setEnumType(ExecutionCommercialTreatment, "mono.common.v1.ExecutionCommercialTreatment", [
    {
        no: 0,
        name: "EXECUTION_COMMERCIAL_TREATMENT_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_COMMERCIAL_TREATMENT_SEPARATELY_INVOICED"
    },
    {
        no: 2,
        name: "EXECUTION_COMMERCIAL_TREATMENT_INCLUDED_IN_CLIN_PRICE"
    },
    {
        no: 3,
        name: "EXECUTION_COMMERCIAL_TREATMENT_NOT_SEPARATELY_PRICED"
    },
    {
        no: 4,
        name: "EXECUTION_COMMERCIAL_TREATMENT_NON_BILLABLE"
    },
    {
        no: 5,
        name: "EXECUTION_COMMERCIAL_TREATMENT_UNFUNDED"
    },
    {
        no: 6,
        name: "EXECUTION_COMMERCIAL_TREATMENT_POTENTIAL_CHANGE"
    },
    {
        no: 7,
        name: "EXECUTION_COMMERCIAL_TREATMENT_DISPUTED"
    },
    {
        no: 8,
        name: "EXECUTION_COMMERCIAL_TREATMENT_UNKNOWN"
    }
]);
/**
 * ExecutionScopeAssessment is independent of disposition and tracking mode.
 *
 * @generated from enum mono.common.v1.ExecutionScopeAssessment
 */ export var ExecutionScopeAssessment = /*#__PURE__*/ function(ExecutionScopeAssessment) {
    /**
   * @generated from enum value: EXECUTION_SCOPE_ASSESSMENT_UNSPECIFIED = 0;
   */ ExecutionScopeAssessment[ExecutionScopeAssessment["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ASSESSMENT_IN_SCOPE = 1;
   */ ExecutionScopeAssessment[ExecutionScopeAssessment["IN_SCOPE"] = 1] = "IN_SCOPE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ASSESSMENT_POTENTIAL_SCOPE_GROWTH = 2;
   */ ExecutionScopeAssessment[ExecutionScopeAssessment["POTENTIAL_SCOPE_GROWTH"] = 2] = "POTENTIAL_SCOPE_GROWTH";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ASSESSMENT_OUT_OF_SCOPE = 3;
   */ ExecutionScopeAssessment[ExecutionScopeAssessment["OUT_OF_SCOPE"] = 3] = "OUT_OF_SCOPE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ASSESSMENT_DISPUTED = 4;
   */ ExecutionScopeAssessment[ExecutionScopeAssessment["DISPUTED"] = 4] = "DISPUTED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ASSESSMENT_UNKNOWN = 5;
   */ ExecutionScopeAssessment[ExecutionScopeAssessment["UNKNOWN"] = 5] = "UNKNOWN";
    return ExecutionScopeAssessment;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionScopeAssessment)
proto3.util.setEnumType(ExecutionScopeAssessment, "mono.common.v1.ExecutionScopeAssessment", [
    {
        no: 0,
        name: "EXECUTION_SCOPE_ASSESSMENT_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SCOPE_ASSESSMENT_IN_SCOPE"
    },
    {
        no: 2,
        name: "EXECUTION_SCOPE_ASSESSMENT_POTENTIAL_SCOPE_GROWTH"
    },
    {
        no: 3,
        name: "EXECUTION_SCOPE_ASSESSMENT_OUT_OF_SCOPE"
    },
    {
        no: 4,
        name: "EXECUTION_SCOPE_ASSESSMENT_DISPUTED"
    },
    {
        no: 5,
        name: "EXECUTION_SCOPE_ASSESSMENT_UNKNOWN"
    }
]);
/**
 * ExecutionPerformanceDisposition is intentionally explicit rather than a
 * generic excluded flag. FULFILLED_ELSEWHERE must not be flattened into WAIVED.
 *
 * @generated from enum mono.common.v1.ExecutionPerformanceDisposition
 */ export var ExecutionPerformanceDisposition = /*#__PURE__*/ function(ExecutionPerformanceDisposition) {
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_UNSPECIFIED = 0;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_PERFORMED_HERE = 1;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["PERFORMED_HERE"] = 1] = "PERFORMED_HERE";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_FULFILLED_ELSEWHERE = 2;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["FULFILLED_ELSEWHERE"] = 2] = "FULFILLED_ELSEWHERE";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_BASE_SCOPE = 3;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["BASE_SCOPE"] = 3] = "BASE_SCOPE";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_SHARED_DELIVERY = 4;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["SHARED_DELIVERY"] = 4] = "SHARED_DELIVERY";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_DUPLICATE_NO_SEPARATE_DELIVERY = 5;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["DUPLICATE_NO_SEPARATE_DELIVERY"] = 5] = "DUPLICATE_NO_SEPARATE_DELIVERY";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_NOT_APPLICABLE = 6;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["NOT_APPLICABLE"] = 6] = "NOT_APPLICABLE";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_OUT_OF_SCOPE = 7;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["OUT_OF_SCOPE"] = 7] = "OUT_OF_SCOPE";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_WAIVED = 8;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["WAIVED"] = 8] = "WAIVED";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_DEFERRED_PENDING_AUTHORITY = 9;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["DEFERRED_PENDING_AUTHORITY"] = 9] = "DEFERRED_PENDING_AUTHORITY";
    /**
   * @generated from enum value: EXECUTION_PERFORMANCE_DISPOSITION_UNRESOLVED = 10;
   */ ExecutionPerformanceDisposition[ExecutionPerformanceDisposition["UNRESOLVED"] = 10] = "UNRESOLVED";
    return ExecutionPerformanceDisposition;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionPerformanceDisposition)
proto3.util.setEnumType(ExecutionPerformanceDisposition, "mono.common.v1.ExecutionPerformanceDisposition", [
    {
        no: 0,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_PERFORMED_HERE"
    },
    {
        no: 2,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_FULFILLED_ELSEWHERE"
    },
    {
        no: 3,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_BASE_SCOPE"
    },
    {
        no: 4,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_SHARED_DELIVERY"
    },
    {
        no: 5,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_DUPLICATE_NO_SEPARATE_DELIVERY"
    },
    {
        no: 6,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_NOT_APPLICABLE"
    },
    {
        no: 7,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_OUT_OF_SCOPE"
    },
    {
        no: 8,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_WAIVED"
    },
    {
        no: 9,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_DEFERRED_PENDING_AUTHORITY"
    },
    {
        no: 10,
        name: "EXECUTION_PERFORMANCE_DISPOSITION_UNRESOLVED"
    }
]);
/**
 * ExecutionTrackingMode is independent of disposition. PERFORMED_HERE can be
 * own or shared. FULFILLED_ELSEWHERE, NOT_APPLICABLE, and WAIVED normally
 * have no local series.
 *
 * @generated from enum mono.common.v1.ExecutionTrackingMode
 */ export var ExecutionTrackingMode = /*#__PURE__*/ function(ExecutionTrackingMode) {
    /**
   * @generated from enum value: EXECUTION_TRACKING_MODE_UNSPECIFIED = 0;
   */ ExecutionTrackingMode[ExecutionTrackingMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_TRACKING_MODE_OWN_SERIES = 1;
   */ ExecutionTrackingMode[ExecutionTrackingMode["OWN_SERIES"] = 1] = "OWN_SERIES";
    /**
   * @generated from enum value: EXECUTION_TRACKING_MODE_SHARED_SERIES = 2;
   */ ExecutionTrackingMode[ExecutionTrackingMode["SHARED_SERIES"] = 2] = "SHARED_SERIES";
    /**
   * @generated from enum value: EXECUTION_TRACKING_MODE_NO_SERIES = 3;
   */ ExecutionTrackingMode[ExecutionTrackingMode["NO_SERIES"] = 3] = "NO_SERIES";
    /**
   * @generated from enum value: EXECUTION_TRACKING_MODE_AD_HOC_RECORD = 4;
   */ ExecutionTrackingMode[ExecutionTrackingMode["AD_HOC_RECORD"] = 4] = "AD_HOC_RECORD";
    /**
   * @generated from enum value: EXECUTION_TRACKING_MODE_UNRESOLVED = 5;
   */ ExecutionTrackingMode[ExecutionTrackingMode["UNRESOLVED"] = 5] = "UNRESOLVED";
    return ExecutionTrackingMode;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionTrackingMode)
proto3.util.setEnumType(ExecutionTrackingMode, "mono.common.v1.ExecutionTrackingMode", [
    {
        no: 0,
        name: "EXECUTION_TRACKING_MODE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_TRACKING_MODE_OWN_SERIES"
    },
    {
        no: 2,
        name: "EXECUTION_TRACKING_MODE_SHARED_SERIES"
    },
    {
        no: 3,
        name: "EXECUTION_TRACKING_MODE_NO_SERIES"
    },
    {
        no: 4,
        name: "EXECUTION_TRACKING_MODE_AD_HOC_RECORD"
    },
    {
        no: 5,
        name: "EXECUTION_TRACKING_MODE_UNRESOLVED"
    }
]);
/**
 * ExecutionScopeArtifactRelation is the scope ↔ artifact relationship.
 *
 * @generated from enum mono.common.v1.ExecutionScopeArtifactRelation
 */ export var ExecutionScopeArtifactRelation = /*#__PURE__*/ function(ExecutionScopeArtifactRelation) {
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_UNSPECIFIED = 0;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_DEFINED_BY = 1;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["DEFINED_BY"] = 1] = "DEFINED_BY";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_AMENDED_BY = 2;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["AMENDED_BY"] = 2] = "AMENDED_BY";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_SUPPLEMENTED_BY = 3;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["SUPPLEMENTED_BY"] = 3] = "SUPPLEMENTED_BY";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_USES_BASELINE_FROM = 4;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["USES_BASELINE_FROM"] = 4] = "USES_BASELINE_FROM";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_APPROVED_BY = 5;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["APPROVED_BY"] = 5] = "APPROVED_BY";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_EVIDENCED_BY = 6;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["EVIDENCED_BY"] = 6] = "EVIDENCED_BY";
    /**
   * @generated from enum value: EXECUTION_SCOPE_ARTIFACT_RELATION_INCORPORATED_BY = 7;
   */ ExecutionScopeArtifactRelation[ExecutionScopeArtifactRelation["INCORPORATED_BY"] = 7] = "INCORPORATED_BY";
    return ExecutionScopeArtifactRelation;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionScopeArtifactRelation)
proto3.util.setEnumType(ExecutionScopeArtifactRelation, "mono.common.v1.ExecutionScopeArtifactRelation", [
    {
        no: 0,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_DEFINED_BY"
    },
    {
        no: 2,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_AMENDED_BY"
    },
    {
        no: 3,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_SUPPLEMENTED_BY"
    },
    {
        no: 4,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_USES_BASELINE_FROM"
    },
    {
        no: 5,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_APPROVED_BY"
    },
    {
        no: 6,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_EVIDENCED_BY"
    },
    {
        no: 7,
        name: "EXECUTION_SCOPE_ARTIFACT_RELATION_INCORPORATED_BY"
    }
]);
/**
 * ExecutionScopeScopeRelation is the scope ↔ scope relationship.
 *
 * @generated from enum mono.common.v1.ExecutionScopeScopeRelation
 */ export var ExecutionScopeScopeRelation = /*#__PURE__*/ function(ExecutionScopeScopeRelation) {
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_UNSPECIFIED = 0;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_REFERENCES = 1;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["REFERENCES"] = 1] = "REFERENCES";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_INCORPORATES_BY_REFERENCE = 2;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["INCORPORATES_BY_REFERENCE"] = 2] = "INCORPORATES_BY_REFERENCE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_FULFILLS_FOR = 3;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["FULFILLS_FOR"] = 3] = "FULFILLS_FOR";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_SHARES_DELIVERY_WITH = 4;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["SHARES_DELIVERY_WITH"] = 4] = "SHARES_DELIVERY_WITH";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_SPLIT_FROM = 5;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["SPLIT_FROM"] = 5] = "SPLIT_FROM";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_SPLIT_INTO = 6;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["SPLIT_INTO"] = 6] = "SPLIT_INTO";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_MERGED_FROM = 7;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["MERGED_FROM"] = 7] = "MERGED_FROM";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_MERGED_INTO = 8;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["MERGED_INTO"] = 8] = "MERGED_INTO";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_SUPERSEDES = 9;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["SUPERSEDES"] = 9] = "SUPERSEDES";
    /**
   * @generated from enum value: EXECUTION_SCOPE_SCOPE_RELATION_RELATED_TO = 10;
   */ ExecutionScopeScopeRelation[ExecutionScopeScopeRelation["RELATED_TO"] = 10] = "RELATED_TO";
    return ExecutionScopeScopeRelation;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionScopeScopeRelation)
proto3.util.setEnumType(ExecutionScopeScopeRelation, "mono.common.v1.ExecutionScopeScopeRelation", [
    {
        no: 0,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_REFERENCES"
    },
    {
        no: 2,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_INCORPORATES_BY_REFERENCE"
    },
    {
        no: 3,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_FULFILLS_FOR"
    },
    {
        no: 4,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_SHARES_DELIVERY_WITH"
    },
    {
        no: 5,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_SPLIT_FROM"
    },
    {
        no: 6,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_SPLIT_INTO"
    },
    {
        no: 7,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_MERGED_FROM"
    },
    {
        no: 8,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_MERGED_INTO"
    },
    {
        no: 9,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_SUPERSEDES"
    },
    {
        no: 10,
        name: "EXECUTION_SCOPE_SCOPE_RELATION_RELATED_TO"
    }
]);
/**
 * ExecutionScopeLineRole is the scope ↔ contract-line relationship.
 *
 * @generated from enum mono.common.v1.ExecutionScopeLineRole
 */ export var ExecutionScopeLineRole = /*#__PURE__*/ function(ExecutionScopeLineRole) {
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_UNSPECIFIED = 0;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_PERFORMANCE_LINE = 1;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["PERFORMANCE_LINE"] = 1] = "PERFORMANCE_LINE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_FUNDING_LINE = 2;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["FUNDING_LINE"] = 2] = "FUNDING_LINE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_INVOICE_LINE = 3;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["INVOICE_LINE"] = 3] = "INVOICE_LINE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_DELIVERABLE_LINE = 4;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["DELIVERABLE_LINE"] = 4] = "DELIVERABLE_LINE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_SUPPORTING_LINE = 5;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["SUPPORTING_LINE"] = 5] = "SUPPORTING_LINE";
    /**
   * @generated from enum value: EXECUTION_SCOPE_LINE_ROLE_UNKNOWN_LINE_ROLE = 6;
   */ ExecutionScopeLineRole[ExecutionScopeLineRole["UNKNOWN_LINE_ROLE"] = 6] = "UNKNOWN_LINE_ROLE";
    return ExecutionScopeLineRole;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionScopeLineRole)
proto3.util.setEnumType(ExecutionScopeLineRole, "mono.common.v1.ExecutionScopeLineRole", [
    {
        no: 0,
        name: "EXECUTION_SCOPE_LINE_ROLE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SCOPE_LINE_ROLE_PERFORMANCE_LINE"
    },
    {
        no: 2,
        name: "EXECUTION_SCOPE_LINE_ROLE_FUNDING_LINE"
    },
    {
        no: 3,
        name: "EXECUTION_SCOPE_LINE_ROLE_INVOICE_LINE"
    },
    {
        no: 4,
        name: "EXECUTION_SCOPE_LINE_ROLE_DELIVERABLE_LINE"
    },
    {
        no: 5,
        name: "EXECUTION_SCOPE_LINE_ROLE_SUPPORTING_LINE"
    },
    {
        no: 6,
        name: "EXECUTION_SCOPE_LINE_ROLE_UNKNOWN_LINE_ROLE"
    }
]);
/**
 * ExecutionLineLineRelation is the line ↔ line relationship.
 *
 * @generated from enum mono.common.v1.ExecutionLineLineRelation
 */ export var ExecutionLineLineRelation = /*#__PURE__*/ function(ExecutionLineLineRelation) {
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_UNSPECIFIED = 0;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_ROLLS_UP_TO = 1;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["ROLLS_UP_TO"] = 1] = "ROLLS_UP_TO";
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_FUNDS = 2;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["FUNDS"] = 2] = "FUNDS";
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_INVOICED_AGAINST = 3;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["INVOICED_AGAINST"] = 3] = "INVOICED_AGAINST";
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_PERFORMANCE_FOR = 4;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["PERFORMANCE_FOR"] = 4] = "PERFORMANCE_FOR";
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_CARRIES_DELIVERABLE_FOR = 5;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["CARRIES_DELIVERABLE_FOR"] = 5] = "CARRIES_DELIVERABLE_FOR";
    /**
   * @generated from enum value: EXECUTION_LINE_LINE_RELATION_CORRESPONDS_TO = 6;
   */ ExecutionLineLineRelation[ExecutionLineLineRelation["CORRESPONDS_TO"] = 6] = "CORRESPONDS_TO";
    return ExecutionLineLineRelation;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionLineLineRelation)
proto3.util.setEnumType(ExecutionLineLineRelation, "mono.common.v1.ExecutionLineLineRelation", [
    {
        no: 0,
        name: "EXECUTION_LINE_LINE_RELATION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_LINE_LINE_RELATION_ROLLS_UP_TO"
    },
    {
        no: 2,
        name: "EXECUTION_LINE_LINE_RELATION_FUNDS"
    },
    {
        no: 3,
        name: "EXECUTION_LINE_LINE_RELATION_INVOICED_AGAINST"
    },
    {
        no: 4,
        name: "EXECUTION_LINE_LINE_RELATION_PERFORMANCE_FOR"
    },
    {
        no: 5,
        name: "EXECUTION_LINE_LINE_RELATION_CARRIES_DELIVERABLE_FOR"
    },
    {
        no: 6,
        name: "EXECUTION_LINE_LINE_RELATION_CORRESPONDS_TO"
    }
]);
/**
 * ExecutionSourceClaimState is the review state of a non-authoritative claim.
 *
 * @generated from enum mono.common.v1.ExecutionSourceClaimState
 */ export var ExecutionSourceClaimState = /*#__PURE__*/ function(ExecutionSourceClaimState) {
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_UNSPECIFIED = 0;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_EXTRACTED = 1;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["EXTRACTED"] = 1] = "EXTRACTED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_UNREVIEWED = 2;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["UNREVIEWED"] = 2] = "UNREVIEWED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_APPROVED = 3;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["APPROVED"] = 3] = "APPROVED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_REJECTED = 4;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["REJECTED"] = 4] = "REJECTED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_CORRECTED = 5;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["CORRECTED"] = 5] = "CORRECTED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_ESCALATED = 6;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["ESCALATED"] = 6] = "ESCALATED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_CLAIM_STATE_SUPERSEDED = 7;
   */ ExecutionSourceClaimState[ExecutionSourceClaimState["SUPERSEDED"] = 7] = "SUPERSEDED";
    return ExecutionSourceClaimState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionSourceClaimState)
proto3.util.setEnumType(ExecutionSourceClaimState, "mono.common.v1.ExecutionSourceClaimState", [
    {
        no: 0,
        name: "EXECUTION_SOURCE_CLAIM_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SOURCE_CLAIM_STATE_EXTRACTED"
    },
    {
        no: 2,
        name: "EXECUTION_SOURCE_CLAIM_STATE_UNREVIEWED"
    },
    {
        no: 3,
        name: "EXECUTION_SOURCE_CLAIM_STATE_APPROVED"
    },
    {
        no: 4,
        name: "EXECUTION_SOURCE_CLAIM_STATE_REJECTED"
    },
    {
        no: 5,
        name: "EXECUTION_SOURCE_CLAIM_STATE_CORRECTED"
    },
    {
        no: 6,
        name: "EXECUTION_SOURCE_CLAIM_STATE_ESCALATED"
    },
    {
        no: 7,
        name: "EXECUTION_SOURCE_CLAIM_STATE_SUPERSEDED"
    }
]);
/**
 * ExecutionEntityLinkVerdict is the linker verdict among bounded candidates.
 *
 * @generated from enum mono.common.v1.ExecutionEntityLinkVerdict
 */ export var ExecutionEntityLinkVerdict = /*#__PURE__*/ function(ExecutionEntityLinkVerdict) {
    /**
   * @generated from enum value: EXECUTION_ENTITY_LINK_VERDICT_UNSPECIFIED = 0;
   */ ExecutionEntityLinkVerdict[ExecutionEntityLinkVerdict["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_ENTITY_LINK_VERDICT_SAME_ENTITY = 1;
   */ ExecutionEntityLinkVerdict[ExecutionEntityLinkVerdict["SAME_ENTITY"] = 1] = "SAME_ENTITY";
    /**
   * @generated from enum value: EXECUTION_ENTITY_LINK_VERDICT_RELATED_BUT_DISTINCT = 2;
   */ ExecutionEntityLinkVerdict[ExecutionEntityLinkVerdict["RELATED_BUT_DISTINCT"] = 2] = "RELATED_BUT_DISTINCT";
    /**
   * @generated from enum value: EXECUTION_ENTITY_LINK_VERDICT_NEW_ENTITY = 3;
   */ ExecutionEntityLinkVerdict[ExecutionEntityLinkVerdict["NEW_ENTITY"] = 3] = "NEW_ENTITY";
    /**
   * @generated from enum value: EXECUTION_ENTITY_LINK_VERDICT_AMBIGUOUS = 4;
   */ ExecutionEntityLinkVerdict[ExecutionEntityLinkVerdict["AMBIGUOUS"] = 4] = "AMBIGUOUS";
    /**
   * @generated from enum value: EXECUTION_ENTITY_LINK_VERDICT_NO_MATCH = 5;
   */ ExecutionEntityLinkVerdict[ExecutionEntityLinkVerdict["NO_MATCH"] = 5] = "NO_MATCH";
    return ExecutionEntityLinkVerdict;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionEntityLinkVerdict)
proto3.util.setEnumType(ExecutionEntityLinkVerdict, "mono.common.v1.ExecutionEntityLinkVerdict", [
    {
        no: 0,
        name: "EXECUTION_ENTITY_LINK_VERDICT_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_ENTITY_LINK_VERDICT_SAME_ENTITY"
    },
    {
        no: 2,
        name: "EXECUTION_ENTITY_LINK_VERDICT_RELATED_BUT_DISTINCT"
    },
    {
        no: 3,
        name: "EXECUTION_ENTITY_LINK_VERDICT_NEW_ENTITY"
    },
    {
        no: 4,
        name: "EXECUTION_ENTITY_LINK_VERDICT_AMBIGUOUS"
    },
    {
        no: 5,
        name: "EXECUTION_ENTITY_LINK_VERDICT_NO_MATCH"
    }
]);
/**
 * ExecutionEvidenceGrade is supporting metadata. A numeric confidence must
 * never be the only reason an authority-sensitive claim auto-applies.
 *
 * @generated from enum mono.common.v1.ExecutionEvidenceGrade
 */ export var ExecutionEvidenceGrade = /*#__PURE__*/ function(ExecutionEvidenceGrade) {
    /**
   * @generated from enum value: EXECUTION_EVIDENCE_GRADE_UNSPECIFIED = 0;
   */ ExecutionEvidenceGrade[ExecutionEvidenceGrade["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_EVIDENCE_GRADE_EXACT_UNIQUE = 1;
   */ ExecutionEvidenceGrade[ExecutionEvidenceGrade["EXACT_UNIQUE"] = 1] = "EXACT_UNIQUE";
    /**
   * @generated from enum value: EXECUTION_EVIDENCE_GRADE_CORROBORATED = 2;
   */ ExecutionEvidenceGrade[ExecutionEvidenceGrade["CORROBORATED"] = 2] = "CORROBORATED";
    /**
   * @generated from enum value: EXECUTION_EVIDENCE_GRADE_AMBIGUOUS = 3;
   */ ExecutionEvidenceGrade[ExecutionEvidenceGrade["AMBIGUOUS"] = 3] = "AMBIGUOUS";
    /**
   * @generated from enum value: EXECUTION_EVIDENCE_GRADE_UNRESOLVED = 4;
   */ ExecutionEvidenceGrade[ExecutionEvidenceGrade["UNRESOLVED"] = 4] = "UNRESOLVED";
    return ExecutionEvidenceGrade;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionEvidenceGrade)
proto3.util.setEnumType(ExecutionEvidenceGrade, "mono.common.v1.ExecutionEvidenceGrade", [
    {
        no: 0,
        name: "EXECUTION_EVIDENCE_GRADE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_EVIDENCE_GRADE_EXACT_UNIQUE"
    },
    {
        no: 2,
        name: "EXECUTION_EVIDENCE_GRADE_CORROBORATED"
    },
    {
        no: 3,
        name: "EXECUTION_EVIDENCE_GRADE_AMBIGUOUS"
    },
    {
        no: 4,
        name: "EXECUTION_EVIDENCE_GRADE_UNRESOLVED"
    }
]);
/**
 * ExecutionAuthorityClass is source authority class, configurable by
 * program/tenant policy. Precedence is not a hardcoded global ranking.
 *
 * @generated from enum mono.common.v1.ExecutionAuthorityClass
 */ export var ExecutionAuthorityClass = /*#__PURE__*/ function(ExecutionAuthorityClass) {
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_UNSPECIFIED = 0;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_CONTRACT_BASELINE = 1;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["CONTRACT_BASELINE"] = 1] = "CONTRACT_BASELINE";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_FORMAL_CONTRACT_CHANGE = 2;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["FORMAL_CONTRACT_CHANGE"] = 2] = "FORMAL_CONTRACT_CHANGE";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_INCORPORATED_OPERATIONAL_ARTIFACT = 3;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["INCORPORATED_OPERATIONAL_ARTIFACT"] = 3] = "INCORPORATED_OPERATIONAL_ARTIFACT";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_STANDALONE_OPERATIONAL_ARTIFACT = 4;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["STANDALONE_OPERATIONAL_ARTIFACT"] = 4] = "STANDALONE_OPERATIONAL_ARTIFACT";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_WRITTEN_CUSTOMER_DIRECTION = 5;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["WRITTEN_CUSTOMER_DIRECTION"] = 5] = "WRITTEN_CUSTOMER_DIRECTION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_INTERNAL_PLAN = 6;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["INTERNAL_PLAN"] = 6] = "INTERNAL_PLAN";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_MANUAL_ASSERTION = 7;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["MANUAL_ASSERTION"] = 7] = "MANUAL_ASSERTION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_CLASS_UNKNOWN = 8;
   */ ExecutionAuthorityClass[ExecutionAuthorityClass["UNKNOWN"] = 8] = "UNKNOWN";
    return ExecutionAuthorityClass;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionAuthorityClass)
proto3.util.setEnumType(ExecutionAuthorityClass, "mono.common.v1.ExecutionAuthorityClass", [
    {
        no: 0,
        name: "EXECUTION_AUTHORITY_CLASS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_AUTHORITY_CLASS_CONTRACT_BASELINE"
    },
    {
        no: 2,
        name: "EXECUTION_AUTHORITY_CLASS_FORMAL_CONTRACT_CHANGE"
    },
    {
        no: 3,
        name: "EXECUTION_AUTHORITY_CLASS_INCORPORATED_OPERATIONAL_ARTIFACT"
    },
    {
        no: 4,
        name: "EXECUTION_AUTHORITY_CLASS_STANDALONE_OPERATIONAL_ARTIFACT"
    },
    {
        no: 5,
        name: "EXECUTION_AUTHORITY_CLASS_WRITTEN_CUSTOMER_DIRECTION"
    },
    {
        no: 6,
        name: "EXECUTION_AUTHORITY_CLASS_INTERNAL_PLAN"
    },
    {
        no: 7,
        name: "EXECUTION_AUTHORITY_CLASS_MANUAL_ASSERTION"
    },
    {
        no: 8,
        name: "EXECUTION_AUTHORITY_CLASS_UNKNOWN"
    }
]);
/**
 * ExecutionSourceAnchorRole identifies why one visual/textual location is
 * attached to a claim. Every extracted fact requires one PRIMARY_CLAIM.
 *
 * @generated from enum mono.common.v1.ExecutionSourceAnchorRole
 */ export var ExecutionSourceAnchorRole = /*#__PURE__*/ function(ExecutionSourceAnchorRole) {
    /**
   * @generated from enum value: EXECUTION_SOURCE_ANCHOR_ROLE_UNSPECIFIED = 0;
   */ ExecutionSourceAnchorRole[ExecutionSourceAnchorRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_ANCHOR_ROLE_PRIMARY_CLAIM = 1;
   */ ExecutionSourceAnchorRole[ExecutionSourceAnchorRole["PRIMARY_CLAIM"] = 1] = "PRIMARY_CLAIM";
    /**
   * @generated from enum value: EXECUTION_SOURCE_ANCHOR_ROLE_CONTEXT = 2;
   */ ExecutionSourceAnchorRole[ExecutionSourceAnchorRole["CONTEXT"] = 2] = "CONTEXT";
    /**
   * @generated from enum value: EXECUTION_SOURCE_ANCHOR_ROLE_TARGET_IDENTIFICATION = 3;
   */ ExecutionSourceAnchorRole[ExecutionSourceAnchorRole["TARGET_IDENTIFICATION"] = 3] = "TARGET_IDENTIFICATION";
    /**
   * @generated from enum value: EXECUTION_SOURCE_ANCHOR_ROLE_AUTHORITY = 4;
   */ ExecutionSourceAnchorRole[ExecutionSourceAnchorRole["AUTHORITY"] = 4] = "AUTHORITY";
    /**
   * @generated from enum value: EXECUTION_SOURCE_ANCHOR_ROLE_COUNTERSOURCE = 5;
   */ ExecutionSourceAnchorRole[ExecutionSourceAnchorRole["COUNTERSOURCE"] = 5] = "COUNTERSOURCE";
    return ExecutionSourceAnchorRole;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionSourceAnchorRole)
proto3.util.setEnumType(ExecutionSourceAnchorRole, "mono.common.v1.ExecutionSourceAnchorRole", [
    {
        no: 0,
        name: "EXECUTION_SOURCE_ANCHOR_ROLE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SOURCE_ANCHOR_ROLE_PRIMARY_CLAIM"
    },
    {
        no: 2,
        name: "EXECUTION_SOURCE_ANCHOR_ROLE_CONTEXT"
    },
    {
        no: 3,
        name: "EXECUTION_SOURCE_ANCHOR_ROLE_TARGET_IDENTIFICATION"
    },
    {
        no: 4,
        name: "EXECUTION_SOURCE_ANCHOR_ROLE_AUTHORITY"
    },
    {
        no: 5,
        name: "EXECUTION_SOURCE_ANCHOR_ROLE_COUNTERSOURCE"
    }
]);
/**
 * ExecutionBboxCoordinateSpace is the persisted coordinate space for a bbox
 * snapshot. Retain source-native coordinates; also expose normalized 0–1.
 * Named Bbox (not BBox) so ENUM_VALUE_PREFIX is EXECUTION_BBOX_* rather than
 * EXECUTION_B_BOX_*.
 *
 * @generated from enum mono.common.v1.ExecutionBboxCoordinateSpace
 */ export var ExecutionBboxCoordinateSpace = /*#__PURE__*/ function(ExecutionBboxCoordinateSpace) {
    /**
   * @generated from enum value: EXECUTION_BBOX_COORDINATE_SPACE_UNSPECIFIED = 0;
   */ ExecutionBboxCoordinateSpace[ExecutionBboxCoordinateSpace["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_BBOX_COORDINATE_SPACE_NORMALIZED_0_1 = 1;
   */ ExecutionBboxCoordinateSpace[ExecutionBboxCoordinateSpace["NORMALIZED_0_1"] = 1] = "NORMALIZED_0_1";
    /**
   * @generated from enum value: EXECUTION_BBOX_COORDINATE_SPACE_PDF_POINTS = 2;
   */ ExecutionBboxCoordinateSpace[ExecutionBboxCoordinateSpace["PDF_POINTS"] = 2] = "PDF_POINTS";
    /**
   * @generated from enum value: EXECUTION_BBOX_COORDINATE_SPACE_PIXELS = 3;
   */ ExecutionBboxCoordinateSpace[ExecutionBboxCoordinateSpace["PIXELS"] = 3] = "PIXELS";
    /**
   * @generated from enum value: EXECUTION_BBOX_COORDINATE_SPACE_SOURCE_NATIVE = 4;
   */ ExecutionBboxCoordinateSpace[ExecutionBboxCoordinateSpace["SOURCE_NATIVE"] = 4] = "SOURCE_NATIVE";
    return ExecutionBboxCoordinateSpace;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionBboxCoordinateSpace)
proto3.util.setEnumType(ExecutionBboxCoordinateSpace, "mono.common.v1.ExecutionBboxCoordinateSpace", [
    {
        no: 0,
        name: "EXECUTION_BBOX_COORDINATE_SPACE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_BBOX_COORDINATE_SPACE_NORMALIZED_0_1"
    },
    {
        no: 2,
        name: "EXECUTION_BBOX_COORDINATE_SPACE_PDF_POINTS"
    },
    {
        no: 3,
        name: "EXECUTION_BBOX_COORDINATE_SPACE_PIXELS"
    },
    {
        no: 4,
        name: "EXECUTION_BBOX_COORDINATE_SPACE_SOURCE_NATIVE"
    }
]);
/**
 * ExecutionSourceUnitCoverageState is exhaustive accounting for every input
 * block/row/unit. UNRESOLVED is successful, honest coverage.
 *
 * @generated from enum mono.common.v1.ExecutionSourceUnitCoverageState
 */ export var ExecutionSourceUnitCoverageState = /*#__PURE__*/ function(ExecutionSourceUnitCoverageState) {
    /**
   * @generated from enum value: EXECUTION_SOURCE_UNIT_COVERAGE_STATE_UNSPECIFIED = 0;
   */ ExecutionSourceUnitCoverageState[ExecutionSourceUnitCoverageState["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_UNIT_COVERAGE_STATE_STRUCTURED = 1;
   */ ExecutionSourceUnitCoverageState[ExecutionSourceUnitCoverageState["STRUCTURED"] = 1] = "STRUCTURED";
    /**
   * @generated from enum value: EXECUTION_SOURCE_UNIT_COVERAGE_STATE_DUPLICATE = 2;
   */ ExecutionSourceUnitCoverageState[ExecutionSourceUnitCoverageState["DUPLICATE"] = 2] = "DUPLICATE";
    /**
   * @generated from enum value: EXECUTION_SOURCE_UNIT_COVERAGE_STATE_BOILERPLATE = 3;
   */ ExecutionSourceUnitCoverageState[ExecutionSourceUnitCoverageState["BOILERPLATE"] = 3] = "BOILERPLATE";
    /**
   * @generated from enum value: EXECUTION_SOURCE_UNIT_COVERAGE_STATE_IRRELEVANT = 4;
   */ ExecutionSourceUnitCoverageState[ExecutionSourceUnitCoverageState["IRRELEVANT"] = 4] = "IRRELEVANT";
    /**
   * @generated from enum value: EXECUTION_SOURCE_UNIT_COVERAGE_STATE_UNRESOLVED = 5;
   */ ExecutionSourceUnitCoverageState[ExecutionSourceUnitCoverageState["UNRESOLVED"] = 5] = "UNRESOLVED";
    return ExecutionSourceUnitCoverageState;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionSourceUnitCoverageState)
proto3.util.setEnumType(ExecutionSourceUnitCoverageState, "mono.common.v1.ExecutionSourceUnitCoverageState", [
    {
        no: 0,
        name: "EXECUTION_SOURCE_UNIT_COVERAGE_STATE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_SOURCE_UNIT_COVERAGE_STATE_STRUCTURED"
    },
    {
        no: 2,
        name: "EXECUTION_SOURCE_UNIT_COVERAGE_STATE_DUPLICATE"
    },
    {
        no: 3,
        name: "EXECUTION_SOURCE_UNIT_COVERAGE_STATE_BOILERPLATE"
    },
    {
        no: 4,
        name: "EXECUTION_SOURCE_UNIT_COVERAGE_STATE_IRRELEVANT"
    },
    {
        no: 5,
        name: "EXECUTION_SOURCE_UNIT_COVERAGE_STATE_UNRESOLVED"
    }
]);
/**
 * ExecutionClaimType is the extraction claim class (schema claimType).
 *
 * @generated from enum mono.common.v1.ExecutionClaimType
 */ export var ExecutionClaimType = /*#__PURE__*/ function(ExecutionClaimType) {
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_UNSPECIFIED = 0;
   */ ExecutionClaimType[ExecutionClaimType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_DOCUMENT_ROLE = 1;
   */ ExecutionClaimType[ExecutionClaimType["DOCUMENT_ROLE"] = 1] = "DOCUMENT_ROLE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_SCOPE = 2;
   */ ExecutionClaimType[ExecutionClaimType["SCOPE"] = 2] = "SCOPE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_REVISION = 3;
   */ ExecutionClaimType[ExecutionClaimType["REVISION"] = 3] = "REVISION";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_DATE = 4;
   */ ExecutionClaimType[ExecutionClaimType["DATE"] = 4] = "DATE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_AUTHORITY_REFERENCE = 5;
   */ ExecutionClaimType[ExecutionClaimType["AUTHORITY_REFERENCE"] = 5] = "AUTHORITY_REFERENCE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_CONTRACT_LINE = 6;
   */ ExecutionClaimType[ExecutionClaimType["CONTRACT_LINE"] = 6] = "CONTRACT_LINE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_OBLIGATION = 7;
   */ ExecutionClaimType[ExecutionClaimType["OBLIGATION"] = 7] = "OBLIGATION";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_DELIVERABLE = 8;
   */ ExecutionClaimType[ExecutionClaimType["DELIVERABLE"] = 8] = "DELIVERABLE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_DISPOSITION_RULE = 9;
   */ ExecutionClaimType[ExecutionClaimType["DISPOSITION_RULE"] = 9] = "DISPOSITION_RULE";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_WORK_ITEM = 10;
   */ ExecutionClaimType[ExecutionClaimType["WORK_ITEM"] = 10] = "WORK_ITEM";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_SCOPE_RELATIONSHIP = 11;
   */ ExecutionClaimType[ExecutionClaimType["SCOPE_RELATIONSHIP"] = 11] = "SCOPE_RELATIONSHIP";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_PERSON_ORGANIZATION = 12;
   */ ExecutionClaimType[ExecutionClaimType["PERSON_ORGANIZATION"] = 12] = "PERSON_ORGANIZATION";
    /**
   * @generated from enum value: EXECUTION_CLAIM_TYPE_ASSUMPTION_CONSTRAINT = 13;
   */ ExecutionClaimType[ExecutionClaimType["ASSUMPTION_CONSTRAINT"] = 13] = "ASSUMPTION_CONSTRAINT";
    return ExecutionClaimType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionClaimType)
proto3.util.setEnumType(ExecutionClaimType, "mono.common.v1.ExecutionClaimType", [
    {
        no: 0,
        name: "EXECUTION_CLAIM_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_CLAIM_TYPE_DOCUMENT_ROLE"
    },
    {
        no: 2,
        name: "EXECUTION_CLAIM_TYPE_SCOPE"
    },
    {
        no: 3,
        name: "EXECUTION_CLAIM_TYPE_REVISION"
    },
    {
        no: 4,
        name: "EXECUTION_CLAIM_TYPE_DATE"
    },
    {
        no: 5,
        name: "EXECUTION_CLAIM_TYPE_AUTHORITY_REFERENCE"
    },
    {
        no: 6,
        name: "EXECUTION_CLAIM_TYPE_CONTRACT_LINE"
    },
    {
        no: 7,
        name: "EXECUTION_CLAIM_TYPE_OBLIGATION"
    },
    {
        no: 8,
        name: "EXECUTION_CLAIM_TYPE_DELIVERABLE"
    },
    {
        no: 9,
        name: "EXECUTION_CLAIM_TYPE_DISPOSITION_RULE"
    },
    {
        no: 10,
        name: "EXECUTION_CLAIM_TYPE_WORK_ITEM"
    },
    {
        no: 11,
        name: "EXECUTION_CLAIM_TYPE_SCOPE_RELATIONSHIP"
    },
    {
        no: 12,
        name: "EXECUTION_CLAIM_TYPE_PERSON_ORGANIZATION"
    },
    {
        no: 13,
        name: "EXECUTION_CLAIM_TYPE_ASSUMPTION_CONSTRAINT"
    }
]);
/**
 * ExecutionDateClaimType classifies a date claim. Do not silently normalize
 * a suspicious year or ambiguous locale.
 *
 * @generated from enum mono.common.v1.ExecutionDateClaimType
 */ export var ExecutionDateClaimType = /*#__PURE__*/ function(ExecutionDateClaimType) {
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_UNSPECIFIED = 0;
   */ ExecutionDateClaimType[ExecutionDateClaimType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_COVER_DATE = 1;
   */ ExecutionDateClaimType[ExecutionDateClaimType["COVER_DATE"] = 1] = "COVER_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_DRAFT_DATE = 2;
   */ ExecutionDateClaimType[ExecutionDateClaimType["DRAFT_DATE"] = 2] = "DRAFT_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_REVISION_DATE = 3;
   */ ExecutionDateClaimType[ExecutionDateClaimType["REVISION_DATE"] = 3] = "REVISION_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_APPROVAL_DATE = 4;
   */ ExecutionDateClaimType[ExecutionDateClaimType["APPROVAL_DATE"] = 4] = "APPROVAL_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_SIGNED_DATE = 5;
   */ ExecutionDateClaimType[ExecutionDateClaimType["SIGNED_DATE"] = 5] = "SIGNED_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_EFFECTIVE_DATE = 6;
   */ ExecutionDateClaimType[ExecutionDateClaimType["EFFECTIVE_DATE"] = 6] = "EFFECTIVE_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_POP_START = 7;
   */ ExecutionDateClaimType[ExecutionDateClaimType["POP_START"] = 7] = "POP_START";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_POP_END = 8;
   */ ExecutionDateClaimType[ExecutionDateClaimType["POP_END"] = 8] = "POP_END";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_MILESTONE_DATE = 9;
   */ ExecutionDateClaimType[ExecutionDateClaimType["MILESTONE_DATE"] = 9] = "MILESTONE_DATE";
    /**
   * @generated from enum value: EXECUTION_DATE_CLAIM_TYPE_UNKNOWN_DATE = 10;
   */ ExecutionDateClaimType[ExecutionDateClaimType["UNKNOWN_DATE"] = 10] = "UNKNOWN_DATE";
    return ExecutionDateClaimType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionDateClaimType)
proto3.util.setEnumType(ExecutionDateClaimType, "mono.common.v1.ExecutionDateClaimType", [
    {
        no: 0,
        name: "EXECUTION_DATE_CLAIM_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_DATE_CLAIM_TYPE_COVER_DATE"
    },
    {
        no: 2,
        name: "EXECUTION_DATE_CLAIM_TYPE_DRAFT_DATE"
    },
    {
        no: 3,
        name: "EXECUTION_DATE_CLAIM_TYPE_REVISION_DATE"
    },
    {
        no: 4,
        name: "EXECUTION_DATE_CLAIM_TYPE_APPROVAL_DATE"
    },
    {
        no: 5,
        name: "EXECUTION_DATE_CLAIM_TYPE_SIGNED_DATE"
    },
    {
        no: 6,
        name: "EXECUTION_DATE_CLAIM_TYPE_EFFECTIVE_DATE"
    },
    {
        no: 7,
        name: "EXECUTION_DATE_CLAIM_TYPE_POP_START"
    },
    {
        no: 8,
        name: "EXECUTION_DATE_CLAIM_TYPE_POP_END"
    },
    {
        no: 9,
        name: "EXECUTION_DATE_CLAIM_TYPE_MILESTONE_DATE"
    },
    {
        no: 10,
        name: "EXECUTION_DATE_CLAIM_TYPE_UNKNOWN_DATE"
    }
]);
/**
 * ExecutionAuthorityReferenceKind is the referenced authority artifact class.
 *
 * @generated from enum mono.common.v1.ExecutionAuthorityReferenceKind
 */ export var ExecutionAuthorityReferenceKind = /*#__PURE__*/ function(ExecutionAuthorityReferenceKind) {
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_UNSPECIFIED = 0;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_AWARD = 1;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["AWARD"] = 1] = "AWARD";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_TASK_ORDER = 2;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["TASK_ORDER"] = 2] = "TASK_ORDER";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_MODIFICATION = 3;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["MODIFICATION"] = 3] = "MODIFICATION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_PWS = 4;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["PWS"] = 4] = "PWS";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_SOW = 5;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["SOW"] = 5] = "SOW";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_EXECUTION_PLAN = 6;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["EXECUTION_PLAN"] = 6] = "EXECUTION_PLAN";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_LOE = 7;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["LOE"] = 7] = "LOE";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_WORK_AUTHORIZATION = 8;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["WORK_AUTHORIZATION"] = 8] = "WORK_AUTHORIZATION";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_CLAUSE = 9;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["CLAUSE"] = 9] = "CLAUSE";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_EMAIL_APPROVAL = 10;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["EMAIL_APPROVAL"] = 10] = "EMAIL_APPROVAL";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_MEMORANDUM = 11;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["MEMORANDUM"] = 11] = "MEMORANDUM";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_KIND_OTHER = 12;
   */ ExecutionAuthorityReferenceKind[ExecutionAuthorityReferenceKind["OTHER"] = 12] = "OTHER";
    return ExecutionAuthorityReferenceKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionAuthorityReferenceKind)
proto3.util.setEnumType(ExecutionAuthorityReferenceKind, "mono.common.v1.ExecutionAuthorityReferenceKind", [
    {
        no: 0,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_AWARD"
    },
    {
        no: 2,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_TASK_ORDER"
    },
    {
        no: 3,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_MODIFICATION"
    },
    {
        no: 4,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_PWS"
    },
    {
        no: 5,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_SOW"
    },
    {
        no: 6,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_EXECUTION_PLAN"
    },
    {
        no: 7,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_LOE"
    },
    {
        no: 8,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_WORK_AUTHORIZATION"
    },
    {
        no: 9,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_CLAUSE"
    },
    {
        no: 10,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_EMAIL_APPROVAL"
    },
    {
        no: 11,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_MEMORANDUM"
    },
    {
        no: 12,
        name: "EXECUTION_AUTHORITY_REFERENCE_KIND_OTHER"
    }
]);
/**
 * ExecutionAuthorityReferenceRelation distinguishes how an artifact cites
 * another authority. A SOW referencing a conformed PWS from a modification
 * does not prove that modification funded the SOW period.
 *
 * @generated from enum mono.common.v1.ExecutionAuthorityReferenceRelation
 */ export var ExecutionAuthorityReferenceRelation = /*#__PURE__*/ function(ExecutionAuthorityReferenceRelation) {
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_UNSPECIFIED = 0;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_USES_BASELINE_FROM = 1;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["USES_BASELINE_FROM"] = 1] = "USES_BASELINE_FROM";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_AUTHORIZED_BY = 2;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["AUTHORIZED_BY"] = 2] = "AUTHORIZED_BY";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_FUNDED_BY = 3;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["FUNDED_BY"] = 3] = "FUNDED_BY";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_EXERCISED_BY = 4;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["EXERCISED_BY"] = 4] = "EXERCISED_BY";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_INCORPORATED_BY = 5;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["INCORPORATED_BY"] = 5] = "INCORPORATED_BY";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_APPROVED_BY = 6;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["APPROVED_BY"] = 6] = "APPROVED_BY";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_REFERENCES = 7;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["REFERENCES"] = 7] = "REFERENCES";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_REFERENCE_RELATION_UNKNOWN = 8;
   */ ExecutionAuthorityReferenceRelation[ExecutionAuthorityReferenceRelation["UNKNOWN"] = 8] = "UNKNOWN";
    return ExecutionAuthorityReferenceRelation;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionAuthorityReferenceRelation)
proto3.util.setEnumType(ExecutionAuthorityReferenceRelation, "mono.common.v1.ExecutionAuthorityReferenceRelation", [
    {
        no: 0,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_USES_BASELINE_FROM"
    },
    {
        no: 2,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_AUTHORIZED_BY"
    },
    {
        no: 3,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_FUNDED_BY"
    },
    {
        no: 4,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_EXERCISED_BY"
    },
    {
        no: 5,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_INCORPORATED_BY"
    },
    {
        no: 6,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_APPROVED_BY"
    },
    {
        no: 7,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_REFERENCES"
    },
    {
        no: 8,
        name: "EXECUTION_AUTHORITY_REFERENCE_RELATION_UNKNOWN"
    }
]);
/**
 * ExecutionArtifactCompleteness records whether the artifact appears complete.
 *
 * @generated from enum mono.common.v1.ExecutionArtifactCompleteness
 */ export var ExecutionArtifactCompleteness = /*#__PURE__*/ function(ExecutionArtifactCompleteness) {
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_COMPLETENESS_UNSPECIFIED = 0;
   */ ExecutionArtifactCompleteness[ExecutionArtifactCompleteness["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_COMPLETENESS_COMPLETE = 1;
   */ ExecutionArtifactCompleteness[ExecutionArtifactCompleteness["COMPLETE"] = 1] = "COMPLETE";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_COMPLETENESS_PARTIAL = 2;
   */ ExecutionArtifactCompleteness[ExecutionArtifactCompleteness["PARTIAL"] = 2] = "PARTIAL";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_COMPLETENESS_DUPLICATE = 3;
   */ ExecutionArtifactCompleteness[ExecutionArtifactCompleteness["DUPLICATE"] = 3] = "DUPLICATE";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_COMPLETENESS_BUNDLED = 4;
   */ ExecutionArtifactCompleteness[ExecutionArtifactCompleteness["BUNDLED"] = 4] = "BUNDLED";
    /**
   * @generated from enum value: EXECUTION_ARTIFACT_COMPLETENESS_UNKNOWN = 5;
   */ ExecutionArtifactCompleteness[ExecutionArtifactCompleteness["UNKNOWN"] = 5] = "UNKNOWN";
    return ExecutionArtifactCompleteness;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionArtifactCompleteness)
proto3.util.setEnumType(ExecutionArtifactCompleteness, "mono.common.v1.ExecutionArtifactCompleteness", [
    {
        no: 0,
        name: "EXECUTION_ARTIFACT_COMPLETENESS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_ARTIFACT_COMPLETENESS_COMPLETE"
    },
    {
        no: 2,
        name: "EXECUTION_ARTIFACT_COMPLETENESS_PARTIAL"
    },
    {
        no: 3,
        name: "EXECUTION_ARTIFACT_COMPLETENESS_DUPLICATE"
    },
    {
        no: 4,
        name: "EXECUTION_ARTIFACT_COMPLETENESS_BUNDLED"
    },
    {
        no: 5,
        name: "EXECUTION_ARTIFACT_COMPLETENESS_UNKNOWN"
    }
]);
/**
 * ExecutionExtractionStatus is the extractor summary status. COMPLETED
 * requires 100% source-unit accounting; UNRESOLVED units are allowed.
 *
 * @generated from enum mono.common.v1.ExecutionExtractionStatus
 */ export var ExecutionExtractionStatus = /*#__PURE__*/ function(ExecutionExtractionStatus) {
    /**
   * @generated from enum value: EXECUTION_EXTRACTION_STATUS_UNSPECIFIED = 0;
   */ ExecutionExtractionStatus[ExecutionExtractionStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_EXTRACTION_STATUS_COMPLETED = 1;
   */ ExecutionExtractionStatus[ExecutionExtractionStatus["COMPLETED"] = 1] = "COMPLETED";
    /**
   * @generated from enum value: EXECUTION_EXTRACTION_STATUS_PARTIAL = 2;
   */ ExecutionExtractionStatus[ExecutionExtractionStatus["PARTIAL"] = 2] = "PARTIAL";
    /**
   * @generated from enum value: EXECUTION_EXTRACTION_STATUS_FAILED = 3;
   */ ExecutionExtractionStatus[ExecutionExtractionStatus["FAILED"] = 3] = "FAILED";
    return ExecutionExtractionStatus;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionExtractionStatus)
proto3.util.setEnumType(ExecutionExtractionStatus, "mono.common.v1.ExecutionExtractionStatus", [
    {
        no: 0,
        name: "EXECUTION_EXTRACTION_STATUS_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_EXTRACTION_STATUS_COMPLETED"
    },
    {
        no: 2,
        name: "EXECUTION_EXTRACTION_STATUS_PARTIAL"
    },
    {
        no: 3,
        name: "EXECUTION_EXTRACTION_STATUS_FAILED"
    }
]);
/**
 * ExecutionReviewRequirement gates auto-apply. High-risk dispositions never
 * auto-apply without review.
 *
 * @generated from enum mono.common.v1.ExecutionReviewRequirement
 */ export var ExecutionReviewRequirement = /*#__PURE__*/ function(ExecutionReviewRequirement) {
    /**
   * @generated from enum value: EXECUTION_REVIEW_REQUIREMENT_UNSPECIFIED = 0;
   */ ExecutionReviewRequirement[ExecutionReviewRequirement["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_REVIEW_REQUIREMENT_MAY_BULK_REVIEW = 1;
   */ ExecutionReviewRequirement[ExecutionReviewRequirement["MAY_BULK_REVIEW"] = 1] = "MAY_BULK_REVIEW";
    /**
   * @generated from enum value: EXECUTION_REVIEW_REQUIREMENT_REVIEW_REQUIRED = 2;
   */ ExecutionReviewRequirement[ExecutionReviewRequirement["REVIEW_REQUIRED"] = 2] = "REVIEW_REQUIRED";
    /**
   * @generated from enum value: EXECUTION_REVIEW_REQUIREMENT_BLOCKING_REVIEW_REQUIRED = 3;
   */ ExecutionReviewRequirement[ExecutionReviewRequirement["BLOCKING_REVIEW_REQUIRED"] = 3] = "BLOCKING_REVIEW_REQUIRED";
    return ExecutionReviewRequirement;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionReviewRequirement)
proto3.util.setEnumType(ExecutionReviewRequirement, "mono.common.v1.ExecutionReviewRequirement", [
    {
        no: 0,
        name: "EXECUTION_REVIEW_REQUIREMENT_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_REVIEW_REQUIREMENT_MAY_BULK_REVIEW"
    },
    {
        no: 2,
        name: "EXECUTION_REVIEW_REQUIREMENT_REVIEW_REQUIRED"
    },
    {
        no: 3,
        name: "EXECUTION_REVIEW_REQUIREMENT_BLOCKING_REVIEW_REQUIRED"
    }
]);
/**
 * ExecutionExerciseAllocationType supports FULL, PARTIAL, and UNKNOWN. Do
 * not require amounts where the source only establishes operational association.
 *
 * @generated from enum mono.common.v1.ExecutionExerciseAllocationType
 */ export var ExecutionExerciseAllocationType = /*#__PURE__*/ function(ExecutionExerciseAllocationType) {
    /**
   * @generated from enum value: EXECUTION_EXERCISE_ALLOCATION_TYPE_UNSPECIFIED = 0;
   */ ExecutionExerciseAllocationType[ExecutionExerciseAllocationType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_EXERCISE_ALLOCATION_TYPE_FULL = 1;
   */ ExecutionExerciseAllocationType[ExecutionExerciseAllocationType["FULL"] = 1] = "FULL";
    /**
   * @generated from enum value: EXECUTION_EXERCISE_ALLOCATION_TYPE_PARTIAL = 2;
   */ ExecutionExerciseAllocationType[ExecutionExerciseAllocationType["PARTIAL"] = 2] = "PARTIAL";
    /**
   * @generated from enum value: EXECUTION_EXERCISE_ALLOCATION_TYPE_UNKNOWN = 3;
   */ ExecutionExerciseAllocationType[ExecutionExerciseAllocationType["UNKNOWN"] = 3] = "UNKNOWN";
    return ExecutionExerciseAllocationType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionExerciseAllocationType)
proto3.util.setEnumType(ExecutionExerciseAllocationType, "mono.common.v1.ExecutionExerciseAllocationType", [
    {
        no: 0,
        name: "EXECUTION_EXERCISE_ALLOCATION_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_EXERCISE_ALLOCATION_TYPE_FULL"
    },
    {
        no: 2,
        name: "EXECUTION_EXERCISE_ALLOCATION_TYPE_PARTIAL"
    },
    {
        no: 3,
        name: "EXECUTION_EXERCISE_ALLOCATION_TYPE_UNKNOWN"
    }
]);
/**
 * ExecutionContractChangeSetType extends the canonical ContractChangeSet
 * string values. Wire strings on ContractChangeSet.change_set_type remain:
 * AwardImport | Modification | ManualCorrection | ReExtraction | PricingSheet
 * | ExecutionScopeImport | ExecutionScopeRevision | ExecutionScopeManualCorrection.
 * This enum is the typed freeze for new execution-scope apply paths; do not
 * renumber the existing string field.
 *
 * @generated from enum mono.common.v1.ExecutionContractChangeSetType
 */ export var ExecutionContractChangeSetType = /*#__PURE__*/ function(ExecutionContractChangeSetType) {
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_UNSPECIFIED = 0;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_AWARD_IMPORT = 1;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["AWARD_IMPORT"] = 1] = "AWARD_IMPORT";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_MODIFICATION = 2;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["MODIFICATION"] = 2] = "MODIFICATION";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_MANUAL_CORRECTION = 3;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["MANUAL_CORRECTION"] = 3] = "MANUAL_CORRECTION";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_RE_EXTRACTION = 4;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["RE_EXTRACTION"] = 4] = "RE_EXTRACTION";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_PRICING_SHEET = 5;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["PRICING_SHEET"] = 5] = "PRICING_SHEET";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_EXECUTION_SCOPE_IMPORT = 6;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["EXECUTION_SCOPE_IMPORT"] = 6] = "EXECUTION_SCOPE_IMPORT";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_EXECUTION_SCOPE_REVISION = 7;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["EXECUTION_SCOPE_REVISION"] = 7] = "EXECUTION_SCOPE_REVISION";
    /**
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_EXECUTION_SCOPE_MANUAL_CORRECTION = 8;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["EXECUTION_SCOPE_MANUAL_CORRECTION"] = 8] = "EXECUTION_SCOPE_MANUAL_CORRECTION";
    /**
   * S8: a SOW/EP's unsettled facts ride the program's ContractIntake set.
   *
   * @generated from enum value: EXECUTION_CONTRACT_CHANGE_SET_TYPE_CONTRACT_INTAKE = 9;
   */ ExecutionContractChangeSetType[ExecutionContractChangeSetType["CONTRACT_INTAKE"] = 9] = "CONTRACT_INTAKE";
    return ExecutionContractChangeSetType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionContractChangeSetType)
proto3.util.setEnumType(ExecutionContractChangeSetType, "mono.common.v1.ExecutionContractChangeSetType", [
    {
        no: 0,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_AWARD_IMPORT"
    },
    {
        no: 2,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_MODIFICATION"
    },
    {
        no: 3,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_MANUAL_CORRECTION"
    },
    {
        no: 4,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_RE_EXTRACTION"
    },
    {
        no: 5,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_PRICING_SHEET"
    },
    {
        no: 6,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_EXECUTION_SCOPE_IMPORT"
    },
    {
        no: 7,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_EXECUTION_SCOPE_REVISION"
    },
    {
        no: 8,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_EXECUTION_SCOPE_MANUAL_CORRECTION"
    },
    {
        no: 9,
        name: "EXECUTION_CONTRACT_CHANGE_SET_TYPE_CONTRACT_INTAKE"
    }
]);
/**
 * ExecutionIdentifierKind classifies a contract/vehicle identifier claim.
 *
 * @generated from enum mono.common.v1.ExecutionIdentifierKind
 */ export var ExecutionIdentifierKind = /*#__PURE__*/ function(ExecutionIdentifierKind) {
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_UNSPECIFIED = 0;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_CONTRACT = 1;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["CONTRACT"] = 1] = "CONTRACT";
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_TASK_ORDER = 2;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["TASK_ORDER"] = 2] = "TASK_ORDER";
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_VEHICLE = 3;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["VEHICLE"] = 3] = "VEHICLE";
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_SOLICITATION = 4;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["SOLICITATION"] = 4] = "SOLICITATION";
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_MODIFICATION = 5;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["MODIFICATION"] = 5] = "MODIFICATION";
    /**
   * @generated from enum value: EXECUTION_IDENTIFIER_KIND_OTHER = 6;
   */ ExecutionIdentifierKind[ExecutionIdentifierKind["OTHER"] = 6] = "OTHER";
    return ExecutionIdentifierKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionIdentifierKind)
proto3.util.setEnumType(ExecutionIdentifierKind, "mono.common.v1.ExecutionIdentifierKind", [
    {
        no: 0,
        name: "EXECUTION_IDENTIFIER_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_IDENTIFIER_KIND_CONTRACT"
    },
    {
        no: 2,
        name: "EXECUTION_IDENTIFIER_KIND_TASK_ORDER"
    },
    {
        no: 3,
        name: "EXECUTION_IDENTIFIER_KIND_VEHICLE"
    },
    {
        no: 4,
        name: "EXECUTION_IDENTIFIER_KIND_SOLICITATION"
    },
    {
        no: 5,
        name: "EXECUTION_IDENTIFIER_KIND_MODIFICATION"
    },
    {
        no: 6,
        name: "EXECUTION_IDENTIFIER_KIND_OTHER"
    }
]);
/**
 * ExecutionIssueSeverity classifies an extraction issue.
 *
 * @generated from enum mono.common.v1.ExecutionIssueSeverity
 */ export var ExecutionIssueSeverity = /*#__PURE__*/ function(ExecutionIssueSeverity) {
    /**
   * @generated from enum value: EXECUTION_ISSUE_SEVERITY_UNSPECIFIED = 0;
   */ ExecutionIssueSeverity[ExecutionIssueSeverity["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_ISSUE_SEVERITY_INFO = 1;
   */ ExecutionIssueSeverity[ExecutionIssueSeverity["INFO"] = 1] = "INFO";
    /**
   * @generated from enum value: EXECUTION_ISSUE_SEVERITY_WARNING = 2;
   */ ExecutionIssueSeverity[ExecutionIssueSeverity["WARNING"] = 2] = "WARNING";
    /**
   * @generated from enum value: EXECUTION_ISSUE_SEVERITY_BLOCKING = 3;
   */ ExecutionIssueSeverity[ExecutionIssueSeverity["BLOCKING"] = 3] = "BLOCKING";
    return ExecutionIssueSeverity;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionIssueSeverity)
proto3.util.setEnumType(ExecutionIssueSeverity, "mono.common.v1.ExecutionIssueSeverity", [
    {
        no: 0,
        name: "EXECUTION_ISSUE_SEVERITY_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_ISSUE_SEVERITY_INFO"
    },
    {
        no: 2,
        name: "EXECUTION_ISSUE_SEVERITY_WARNING"
    },
    {
        no: 3,
        name: "EXECUTION_ISSUE_SEVERITY_BLOCKING"
    }
]);
/**
 * ExecutionAuthorityEventType is a normalized authority-plane event. Existing
 * modification ChangeItems and optional-task exercise rows remain canonical.
 *
 * @generated from enum mono.common.v1.ExecutionAuthorityEventType
 */ export var ExecutionAuthorityEventType = /*#__PURE__*/ function(ExecutionAuthorityEventType) {
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_UNSPECIFIED = 0;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_AWARD_ESTABLISHED = 1;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["AWARD_ESTABLISHED"] = 1] = "AWARD_ESTABLISHED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_OPTION_PERIOD_EXERCISED = 2;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["OPTION_PERIOD_EXERCISED"] = 2] = "OPTION_PERIOD_EXERCISED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_OPTIONAL_TASK_EXERCISED = 3;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["OPTIONAL_TASK_EXERCISED"] = 3] = "OPTIONAL_TASK_EXERCISED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_LINE_CREATED_OR_FUNDED = 4;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["LINE_CREATED_OR_FUNDED"] = 4] = "LINE_CREATED_OR_FUNDED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_LINE_DEOBLIGATED = 5;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["LINE_DEOBLIGATED"] = 5] = "LINE_DEOBLIGATED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_POP_EXTENDED = 6;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["POP_EXTENDED"] = 6] = "POP_EXTENDED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_REQUIREMENT_CHANGED = 7;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["REQUIREMENT_CHANGED"] = 7] = "REQUIREMENT_CHANGED";
    /**
   * @generated from enum value: EXECUTION_AUTHORITY_EVENT_TYPE_ARTIFACT_INCORPORATED = 8;
   */ ExecutionAuthorityEventType[ExecutionAuthorityEventType["ARTIFACT_INCORPORATED"] = 8] = "ARTIFACT_INCORPORATED";
    return ExecutionAuthorityEventType;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ExecutionAuthorityEventType)
proto3.util.setEnumType(ExecutionAuthorityEventType, "mono.common.v1.ExecutionAuthorityEventType", [
    {
        no: 0,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_AWARD_ESTABLISHED"
    },
    {
        no: 2,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_OPTION_PERIOD_EXERCISED"
    },
    {
        no: 3,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_OPTIONAL_TASK_EXERCISED"
    },
    {
        no: 4,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_LINE_CREATED_OR_FUNDED"
    },
    {
        no: 5,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_LINE_DEOBLIGATED"
    },
    {
        no: 6,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_POP_EXTENDED"
    },
    {
        no: 7,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_REQUIREMENT_CHANGED"
    },
    {
        no: 8,
        name: "EXECUTION_AUTHORITY_EVENT_TYPE_ARTIFACT_INCORPORATED"
    }
]);
/**
 * ExecutionBBoxSnapshot is a durable bounding-box snapshot tied to one
 * immutable artifact version/rendition. A missing bbox degrades to page/quote
 * provenance; it does not remove the source citation.
 *
 * @generated from message mono.common.v1.ExecutionBBoxSnapshot
 */ export class ExecutionBBoxSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionBBoxSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionBBoxSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionBBoxSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionBBoxSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: double x = 1;
   */ _define_property(this, "x", 0), /**
   * @generated from field: double y = 2;
   */ _define_property(this, "y", 0), /**
   * @generated from field: double width = 3;
   */ _define_property(this, "width", 0), /**
   * @generated from field: double height = 4;
   */ _define_property(this, "height", 0), /**
   * @generated from field: int32 page = 5;
   */ _define_property(this, "page", 0), /**
   * @generated from field: mono.common.v1.ExecutionBboxCoordinateSpace coordinate_space = 6;
   */ _define_property(this, "coordinateSpace", 0), /**
   * @generated from field: double page_width = 7;
   */ _define_property(this, "pageWidth", 0), /**
   * @generated from field: double page_height = 8;
   */ _define_property(this, "pageHeight", 0), /**
   * @generated from field: int32 page_rotation = 9;
   */ _define_property(this, "pageRotation", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionBBoxSnapshot, "runtime", proto3);
_define_property(ExecutionBBoxSnapshot, "typeName", "mono.common.v1.ExecutionBBoxSnapshot");
_define_property(ExecutionBBoxSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "x",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 2,
            name: "y",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "width",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "height",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "coordinate_space",
            kind: "enum",
            T: proto3.getEnumType(ExecutionBboxCoordinateSpace)
        },
        {
            no: 7,
            name: "page_width",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "page_height",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "page_rotation",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExecutionSourceAnchor is one immutable visual/textual location in one
 * artifact version. Shared by extraction output and persisted source_anchors.
 * Block ID and bbox are both stored when available.
 *
 * @generated from message mono.common.v1.ExecutionSourceAnchor
 */ export class ExecutionSourceAnchor extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionSourceAnchor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionSourceAnchor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionSourceAnchor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionSourceAnchor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.common.v1.ExecutionSourceAnchorRole role = 1;
   */ _define_property(this, "role", 0), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 3;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 4;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string rendition_id = 5;
   */ _define_property(this, "renditionId", ""), /**
   * @generated from field: int32 page_number = 6;
   */ _define_property(this, "pageNumber", 0), /**
   * @generated from field: string section_number = 7;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string block_id = 8;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: string parent_block_id = 9;
   */ _define_property(this, "parentBlockId", ""), /**
   * @generated from field: string exact_quote = 10;
   */ _define_property(this, "exactQuote", ""), /**
   * @generated from field: string quote_sha256 = 11;
   */ _define_property(this, "quoteSha256", ""), /**
   * @generated from field: mono.common.v1.ExecutionBBoxSnapshot bbox = 12;
   */ _define_property(this, "bbox", void 0), /**
   * @generated from field: int32 table_row = 13;
   */ _define_property(this, "tableRow", 0), /**
   * @generated from field: int32 table_column = 14;
   */ _define_property(this, "tableColumn", 0), /**
   * @generated from field: string cell_address = 15;
   */ _define_property(this, "cellAddress", ""), /**
   * @generated from field: int32 char_start = 16;
   */ _define_property(this, "charStart", 0), /**
   * @generated from field: int32 char_end = 17;
   */ _define_property(this, "charEnd", 0), /**
   * @generated from field: string extractor_name = 18;
   */ _define_property(this, "extractorName", ""), /**
   * @generated from field: string extractor_version = 19;
   */ _define_property(this, "extractorVersion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionSourceAnchor, "runtime", proto3);
_define_property(ExecutionSourceAnchor, "typeName", "mono.common.v1.ExecutionSourceAnchor");
_define_property(ExecutionSourceAnchor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "enum",
            T: proto3.getEnumType(ExecutionSourceAnchorRole)
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rendition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "page_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "parent_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "exact_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "quote_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "bbox",
            kind: "message",
            T: ExecutionBBoxSnapshot
        },
        {
            no: 13,
            name: "table_row",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "table_column",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "cell_address",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "char_start",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "char_end",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "extractor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "extractor_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
